import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Para qué condiciones se usa la TMS?",
    answer:
      "La TMS convencional está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. SAINT® está autorizado por la FDA para el mismo uso. La TMS también se usa para otros fines; la idoneidad se confirma mediante una evaluación psiquiátrica.",
  },
  {
    question: "¿SAINT® trata la ansiedad, el TEPT o el TOC?",
    answer:
      "SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. No está indicado para ansiedad, trastorno bipolar, TEPT o TOC. No afirmamos que SAINT® trate estas condiciones.",
  },
];

export const esTmsForAnxietyOcdPtsd = makeEsArticle({
  slug: "tms-for-anxiety-ocd-ptsd",
  title: "TMS para ansiedad, TOC y TEPT: lo que dice la FDA",
  description:
    "SAINT® está autorizado por la FDA para el trastorno depresivo mayor, no para ansiedad, TOC o TEPT. La TMS convencional tiene otros usos autorizados. La idoneidad se confirma mediante una evaluación psiquiátrica.",
  h1: "TMS para ansiedad, TOC y TEPT",
  breadcrumbLabel: "TMS para ansiedad, TOC y TEPT",
  shortAnswer:
    "SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. No está indicado para ansiedad, trastorno bipolar, TEPT o TOC. No afirmamos que SAINT® trate estas condiciones. La TMS convencional tiene otros usos autorizados por la FDA. La idoneidad para cualquier uso se confirma mediante una evaluación psiquiátrica.",
  keyTakeaways: [
    "SAINT® está autorizado por la FDA para el trastorno depresivo mayor.",
    "SAINT® no está indicado para ansiedad, trastorno bipolar, TEPT o TOC.",
    "No afirmamos que SAINT® trate estas condiciones.",
    "La TMS convencional tiene otros usos autorizados por la FDA.",
    "La idoneidad se confirma mediante una evaluación psiquiátrica.",
  ],
  sections: [
    {
      heading: "El uso autorizado por la FDA de SAINT®",
      paragraphs: [
        "SAINT® está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. Esta es la indicación autorizada. No está indicado para ansiedad, trastorno bipolar, TEPT o TOC.",
        "No afirmamos que SAINT® trate estas condiciones.",
      ],
    },
    {
      heading: "Otros usos de la TMS",
      paragraphs: [
        "La TMS convencional tiene otros usos autorizados por la FDA además del trastorno depresivo mayor. La idoneidad para cualquier uso se confirma mediante una evaluación psiquiátrica.",
      ],
    },
    {
      heading: "Si tiene ansiedad, TOC o TEPT",
      paragraphs: [
        "Si tiene una de estas condiciones, una evaluación psiquiátrica puede ayudarle a identificar las opciones apropiadas. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
